// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jz3H","textarea":"styles_textarea__1lrIw"};